import React, { useEffect, useState } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import Wrapper from '../../components/Wrapper/Wrapper';
import { tripTableHeight, tableHeightWithSparkline } from "../../../styleVariables";
import { connect } from "react-redux";
import { logoutUser } from "../../../store/actions/authActionCreators";
import MUIDataTable from "mui-datatables";
import {
    getDriverLedger
} from "../../../store/actions/homeActionCreator";
import * as logger from "../../../logger";
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { numberFormat } from '../../../utils/utils'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import useStyles from '../css/listing';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { fetchSingleShopAndTransaction, getShopTransaction, driverSettleAmount, deleteSingleShopTransaction, fetchSingleDriverTransaction, driverAdditionType, driverDeductionType, addReduceDriverTransaction } from '../../../store/actions/vehicleActionCreator';
import { getDateInStringDocumentDDMMMYYYY } from '../../../utils/utils';
import { Dialog } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { Form } from 'react-final-form';
import {
    TextField,
    Checkboxes,
    Radios,
    Select,
    DatePicker,
    TimePicker,
    Autocomplete
} from 'mui-rff';
import NotesIcon from '@material-ui/icons/Notes';
import DateFnsUtils from '@date-io/date-fns';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import DriverGaveAndGot from '../../components/DriverDialogs/DriverGaveAndGot';
import ShopCreditAndPayment from '../../components/Shops/ShopCreditAndPayment';
import DialogActions from '@material-ui/core/DialogActions';
import InfoDialog from '../../components/Dialog/InfoDialog';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import PayShopSideBar from '../../components/RightSideBar/PayShopSideBar';
import TelegramIcon from '@material-ui/icons/Telegram';
import queryString from "query-string";
import SuccessDialog from '../../components/Verfication/SuccessDialog';
import FailureDialog from '../../components/Verfication/FailureDialog';
import {
    getTransactionHistory,
    getSinglePayment,
    getPaymentStatus
} from "../../../store/actions/OnlinePaymentActionCreators";
import TransactionDetailsSideBar from '../../components/RightSideBar/TransactionDetailsSideBar';
import PaymentDetailsCard from '../../components/Payment/PaymentDetailsCard';
import DetailsCard from '../../components/Payment/DetailsCard';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { trackDwebEvent } from '../../analytics';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo,defaultPageSize } from '../../../paginationVariables';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ReportsDialog from '../../components/ReportsDialog/ReportsDialog';
import SingleOnlineTransactionDetailsCard from '../../components/Payment/SingleOnlineTransactionDetailsCard';
import {GetPaymentStatusIconOnly} from '../../components/Payment/GetPaymentStatusIcon';
import DottedDivider from '../../components/Divider/DottedDivider';
import TripListingCard from '../../components/listing/TripListingCard';
const ViewShop = ({ dispatchGetTransactionData, dispatchGetPaymentStatus, dispatchGetPaymentDetails, dispatchDeleteSingleTransaction, dispatchGetDriverDeductionTypes, dispatchGetDriverAdditionTypes, dispatchFetchSingleDriverTransaction, dispatchGetSingleShopAndTransaction, vehicle, user, dispatchSettleDriverAmount }) => {

    let submit;
    let history = useHistory();
    let search = window.location.search;
    const params = queryString.parse(search);
    let orderId = params["order_id"];
    const [initialEmpty, setInitialEmpty] = useState(false);
    const [singleShopData, setSingleShopData] = useState({});
    const [settleModalOpen, setSettleModalOpen] = useState(false);
    const [shopCreditPaymentDialog, setShopCreditPaymentDialog] = useState(false);
    const [recall, setRecall] = useState(false);
    const [type, setType] = useState("");
    const [transType, setTransType] = useState("");
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [transactionId, setTransactionId] = useState("");
    const [infoOpen, setInfoOpen] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [shopPaymentOpen, setShopPaymentOpen] = useState(false);
    const [defaultData, setDefaultData] = useState(null)
    const [successCreation, setSuccessCreation] = useState(false);
    const [failureCreation, setFailureCreation] = useState(false);
    const [transactionData, setTransactionData] = useState({})
    const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
    const [dialogShopCreditPayment, setDialogShopCreditPayment] = useState(false);
    const [eventSent, setEventSent] = useState(false);
    const [selectedShopData, setSelectedShopData] = useState({});
    const [configInfo, setConfigInfo] = useState({});
    const [searchText, setSearchText] = useState("");
    const [currentPageNo,setCurrentPageNo]  = useState(defaultPageNo);
    const [currentPageSize,setCurrentPageSize]  = useState(defaultPageSize);
    const [pdfOpen, setPdfOpen] = useState(false);


    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let shopIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = useStyles();
    const goToViewShop = (data) => {
        history.push({
            pathname: `/shops/shop/${shopIdValue}`,
            state: {
                id: shopIdValue,
                shopBalance: data && data.balance ? data.balance : null,
                pageTitle: data && data.name ? data.name : 'Shop View',
                shopId: shopIdValue
            }
        });
    }
    const handleTransactionDetailsOpen = () => {
        setTransactionDetailsOpen(true)
    }
    const handleTransactionDetailsClose = () => {
        setTransactionDetailsOpen(false)
    }
    useEffect(() => {
        var data = {
            pageNo: defaultPageNo,
            pageSize: defaultPageSize
        }

        dispatchGetSingleShopAndTransaction(shopIdValue, data,
            (data) => {
                logger.log("singleShopComponent", "Single Shop Fetch Successfull");
                if (!eventSent) {
                    trackDwebEvent('Dweb Single Shop Page', {
                        shop_id: shopIdValue,
                        shop_name: data.response && data.response.name ? data.response.name : '',
                        contact_number: data.response && data.response.contactNumber ? data.response.contactNumber : '',
                        balance: data.response && data.response.balance ? data.response.balance : '',
                    });
                    setEventSent(true);
                }
                if (data && data.status && data.status.code == 200 && data.response && data.response.transactions && data.response.transactions <= 0) {
                    setInitialEmpty(true)
                } else {
                    setInitialEmpty(false)
                }
                if (orderId) {
                    setSelectedShopData(data)
                    dispatchGetPaymentStatus({
                        orderId: orderId
                    }, (response) => {
                        if (response && response.status && response.status.code == 200) {
                            if (response.response.message == "Transaction Failed.") {
                                handleFailureOpen()
                                setTimeout(() => {
                                    handleFailureClose(data)
                                }, 3000);
                            } else {
                                handleSuccessOpen()
                                setTimeout(() => {
                                    handleSuccessClose(data)
                                }, 3000);
                            }
                        } else {
                            handleFailureOpen()
                            setTimeout(() => {
                                handleFailureClose(data)
                            }, 3000);
                        }
                    }, () => {
                        handleFailureOpen();
                        setTimeout(() => {
                            handleFailureClose(data)
                        }, 3000);
                    })
                }
            },
            () => {
                logger.log("singleShopComponent", "Single Shop Fetch Failed");
            }
        )
    }, [recall]);
    const getPaginatedData =()=>{
        const shopsReqData = {
            pageNo: currentPageNo+1,
            pageSize: currentPageSize,
            searchText: searchText,
            merge:true
        };
        dispatchGetSingleShopAndTransaction(shopIdValue,shopsReqData, () => {

        })
    }
    useEffect(() => {
        if (vehicle && vehicle.singleShopData) {
            if (initialEmpty && vehicle.singleShopData.transactions && vehicle.singleShopData.transactions.length > 0) {
                setInitialEmpty(false)
            }
            setSingleShopData(vehicle.singleShopData);
        }
    }, [vehicle.singleShopData]);


    useEffect(() => {

        if (user && user.configs && user.configs.online_payments_config) {
            setConfigInfo(user.configs.online_payments_config);
        } else {
            setConfigInfo({});
        }

    }, [user.configs]);

    const handlePayShopOpen = () => {
        setDefaultData({
            entityId: shopIdValue,
            entityType: "shop"
        })
        setShopPaymentOpen(true)
    }
    const handlePayAgain= ()=>{
        setTransactionDetailsOpen(false);
        setDefaultData({
            entityId: shopIdValue,
            entityType: "shop",
            amount:transactionData&&transactionData.amount?transactionData.amount:null
        })
        setTransactionData(null);
        setShopPaymentOpen(true)
    }

    const handlePayShopClose = (entityData) => {
        setRecall(!recall);
        setDefaultData(null);
        setShopPaymentOpen(false);
    }

    const handleSuccessOpen = () => {
        setSuccessCreation(true)
    }
    const handleSuccessClose = (data) => {
        setSuccessCreation(false)
        goToViewShop(data && data.response ? data.response : null)
    }
    const handleFailureOpen = () => {
        setFailureCreation(true)
    }
    const handleFailureClose = (data) => {
        setFailureCreation(false)
        goToViewShop(data && data.response ? data.response : null)
    }
    const handleRowClick = (data) => {
        if (data && data.id) {
            if (data.is_broker_enabled) {
                dispatchGetPaymentDetails(
                    {
                        entityType: "shop",
                        transactionId: data.id,
                        entityId:shopIdValue
                    },
                    (response) => {
                        if (response && response.status && response.status.code == 200 && response.response) {
                            response.response.entityType = type;
                            setTransactionData({
                                ...response.response,
                                entityType: "shop",
                                is_broker_enabled: data.is_broker_enabled
                            });
                            setTransactionDetailsOpen(true);
                        }
                    },
                    (response) => {

                    }
                )
            } else {
                dispatchGetTransactionData(
                    {
                        id: shopIdValue,
                        transactionId: data.id
                    },
                    (response) => {
                        if (response && response.status && response.status.code == 200 && response.response) {
                            let type = "";
                            if (response.response.amount && response.response.amount > 0) {
                                type = "Payment"
                            } else if (response.response.amount && response.response.amount < 0) {
                                type = "Credit"
                            }
                            setTransactionData({
                                ...response.response,
                                transactionType: type,
                                entityType: "shopPayment",
                            });
                            setTransactionDetailsOpen(true);
                        }
                    },
                    (response) => {

                    }
                )
            }
        }
    }
    const muiColumns = [
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;
                    if (rowIndex === muiData.length - 3) {
                        return (
                        <>
                            <Waypoint
                            onEnter={() => {
                                if(vehicle && vehicle.singleShopData && vehicle.singleShopData.maxPage && vehicle.singleShopData.maxPage != currentPageNo){
                                    getPaginatedData()
                                    setCurrentPageNo(currentPageNo+1)
                                }
                            }}
                            />
                            <span>{getDateInStringDocumentDDMMMYYYY(value)}</span>
                        </>
                        );
                    } else {
                        return (
                            <>
                                <span>{getDateInStringDocumentDDMMMYYYY(value)}</span>
                            </>
                        )
                    }
                }
            },
        },
        {
            name: "displayName",
            label: "Reason",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    let data = singleShopData.transactions[dataIndex];
                    return (
                        <div style={{ display: 'flex',alignItems:'center' }}>
                            <div className={classes.fw300}>{data && data.description ? data.description : ""}</div>
                            {data && (data.expenseDescription || (data.is_broker_enabled && data.paymentStatus) )?<div style={{ display: 'flex',alignItems:'center' }}>
                                <FiberManualRecordIcon className={classes.indicator} /><Typography className={classes.txType}>{data.expenseDescription}</Typography>
                            </div>:''}
                            {data && data.is_broker_enabled && data.paymentStatus &&
                                    <GetPaymentStatusIconOnly statusTxt={true} type={data.paymentStatus} />
                            }
                        </div>
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Credit",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.shopBalanceDue}>{value < 0 ? numberFormat(Number(Math.abs(value))) : ""}</div>
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Payment",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return (
                        <div className={classes.shopBalanceAdvance}>{value > 0 ? numberFormat(Number(value)) : ""}</div>
                    )
                }
            },
        },
        {
            name: "id",
            label: "Actions",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <>
                            {singleShopData.transactions && singleShopData.transactions[dataIndex] && !singleShopData.transactions[dataIndex].is_broker_enabled &&
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    {!singleShopData.transactions[dataIndex].expenseDescription ? <div>
                                        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid #0033cc', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px' }} onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            handleSingleTransactionEdit(muiData[dataIndex])
                                        }
                                        } ><EditIcon style={{ color: '#0033cc', fontSize: '16px' }} /></IconButton>
                                    </div>:<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>}
                                    <div>
                                        <IconButton variant="outlined" style={{ borderRadius: '4px', border: '1px solid red', paddingTop: '4px', paddingBottom: '4px', paddingLeft: '8px', paddingRight: '8px', marginLeft: '16px' }} onClick={(e) => {
                                            e.preventDefault()
                                            e.stopPropagation()
                                            handleDeleteDialogOpen(muiData[dataIndex])
                                        }} ><DeleteIcon style={{ color: 'red', fontSize: '16px' }} /></IconButton>
                                    </div>
                                </div>
                            }
                        </>
                    )
                }
            },
        },

    ];
    const muiData = singleShopData.transactions;
    const options = {
        rowsPerPage: 100,
        pagination:false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparkline,
        selectableRows: 'none',
        searchOpen: false,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        onRowClick: (rowData, rowMeta) => {
            handleRowClick({
                ...muiData[rowMeta.dataIndex],
                index: muiData[rowMeta.dataIndex],
            })
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search transactions',
        textLabels: {
            body: {
                noMatch: "Sorry, no transactions found",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };


    const handleConfirm = () => {
        setShopCreditPaymentDialog(false);
        setRecall(!recall);
    }

    const handleDeleteDialogClose = () => {
        setDeleteDialog(false);
    }

    const handleDeleteDialogOpen = (data) => {
        const transactionId = data.id;
        setTransactionId(transactionId);
        setDeleteDialog(true);
    }

    const onDeleteTransaction = () => {
        dispatchDeleteSingleTransaction({
            id: transactionId,
            shopId: shopIdValue
        },
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Single shop Component Dweb", "Delete transaction successfull");
                    setDeleteDialog(false);
                    setRecall(!recall);
                }
            },
            () => {
                logger.log("Single Shop Component Dweb", "Delete transaction failed");
            }
        );
    }

    const handleSingleTransactionEdit = (data) => {
        const transactionId = data.id;
        dispatchGetTransactionData(
            {
                id: shopIdValue,
                transactionId: transactionId
            },
            (response) => {
                if (response && response.status && response.status.code == 200 && response.response) {
                    let type = "";
                    if (response.response.amount && response.response.amount > 0) {
                        setType("Payment");
                    } else if (response.response.amount && response.response.amount < 0) {
                        setType("Credit");
                    }
                    setSelectedData(data);
                    setShopCreditPaymentDialog(true);
                }
            },
            (response) => {

            }
        )
    }

    const handleBalanceClose = () => {
        setShopCreditPaymentDialog(false);
    }

    const handleInfoClick = () => {
        setInfoOpen(true);
    }

    const handleInfoClose = () => {
        setInfoOpen(false);
    }
    const goSingleShopCredit = () => {
        setDialogShopCreditPayment(true);
        setTransType("Credit");
    }
    const goSingleShopPayment = () => {
        setDialogShopCreditPayment(true);
        setTransType("Payment");
    }
    const handleShopCreditPaymetClose = () => {
        setDialogShopCreditPayment(false);
        setRecall(!recall);
    }
    const handleShopCreditPaymentConfirm = () => {
        setDialogShopCreditPayment(false);
        setRecall(!recall);
    }

    const handleViewPdf = () => {
        setPdfOpen(true);
    }

    const handlePdfClose = () => {
        setPdfOpen(false);
    }

    return (
        <>
            <Wrapper>
                <Paper className={classes.pageContentDIv} elevation={3}>
                    {initialEmpty ? <div className={classes.listEmptyState}>
                        <img className={classes.listEmptyStateImgShop} style={{ width: 371, height: 227 }} src={`${process.env.PUBLIC_URL}/assets/images/single-shop-empty-state.png`} alt={"Transport Footer"} />
                        <Typography className={classes.listEmptyStateDescSingle} >
                            Add your credits and payments <br />with this shop to get balance
                        </Typography>
                        <div className={classes.listEmptyStateActions}>
                            <Button startIcon={<ArrowDownwardIcon />} variant="contained" onClick={goSingleShopCredit} className={classes.shopCreditButton}>
                                Credit
                            </Button>
                            <Button startIcon={<ArrowUpwardIcon />} variant="contained" color="primary" className={classes.shopPaymentButton} onClick={goSingleShopPayment}>
                                Payment
                            </Button>
                        </div>
                    </div> : <>
                        <Grid container justify="flex-start" spacing={3} direction="row" alignItems="center">
                            <Grid item>
                                <Paper className={classes.infoCard1} >
                                    <div className={classes.divV2}>
                                        <div className={classes.divVRow}>
                                            <Typography variant="subtitle2" className={classes.infoCardTitle2}>
                                                {singleShopData.balance == 0 &&
                                                    <span>
                                                        Balance
                                                    </span>
                                                }
                                                {singleShopData.balance != 0 &&
                                                    <span>
                                                        {singleShopData.balance > 0 ? "Total Advance" : "Total Credit"}
                                                    </span>
                                                }
                                                {/* {singleShopData.balanceText}{singleShopData.balanceText == "Total Balance" && <span> <InfoOutlinedIcon className={classes.infoV1} onClick={handleInfoClick} /></span>} */}
                                            </Typography>
                                            <Typography variant="subtitle2" className={classes.balanceV1}>
                                                {singleShopData.balance == 0 &&
                                                    <span style={{ color: 'black' }}>
                                                        {numberFormat(singleShopData.balance)}
                                                    </span>
                                                }
                                                {singleShopData.balance != 0 &&
                                                    <div className={singleShopData.balance > 0 ? [classes.profit] : [classes.loss]}>{numberFormat(Math.abs(singleShopData.balance))}</div>
                                                }
                                            </Typography>
                                        </div>
                                        {/* {configInfo && configInfo.shopPayout && configInfo.shopPayout.show == 1 &&
                                            <div>
                                                <Button variant="contained" className={classes.buttonSendMoney} onClick={() => { handlePayShopOpen() }}>
                                                    <span><TelegramIcon /> Send Money</span>
                                                </Button>
                                            </div>
                                        } */}

                                        <div>
                                            <Button variant="contained" className={classes.singleShopPdfButton} onClick={() => { handleViewPdf() }}>
                                                <PictureAsPdfIcon />&nbsp;View PDF
                                            </Button>
                                        </div>
                                    </div>
                                </Paper>
                            </Grid>
                        </Grid>
                        <div className={classes.dividerDiv}></div>
                        <div className={classes.singleShopTable}>
                            <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                        </div>
                    </>}
                </Paper>

                {infoOpen && <InfoDialog confirmOpen={infoOpen} confirmTitle={"Total Balance"} confirmMessage={"The total amount to be collected or paid to this driver"} onClose={handleInfoClose} />}

                {/* Delete transaction dialog. */}
                <Dialog
                    fullWidth={true}
                    maxWidth='xs'
                    disableBackdropClick={true} disableEscapeKeyDown={true} open={deleteDialog} onClose={handleDeleteDialogClose}
                >
                    <DialogContent>
                        <div className={classes.divV25}> Delete Transaction</div>
                        <div className={classes.mtV5}>Are you sure you want to delete</div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteDialogClose}>
                            <span className={classes.cancelV1}>
                                NO
                            </span>
                        </Button>
                        <Button onClick={onDeleteTransaction}>
                            <span className={classes.deleteV1}>
                                YES
                            </span>
                        </Button>
                    </DialogActions>
                </Dialog>

            </Wrapper>
            {dialogShopCreditPayment && <ShopCreditAndPayment balanceType={transType} onClose={handleShopCreditPaymetClose} onOpen={dialogShopCreditPayment} shopId={shopIdValue ? shopIdValue : ""} onConfirm={handleShopCreditPaymentConfirm} fromSingleShop={true} />}
            {shopCreditPaymentDialog && <ShopCreditAndPayment balanceType={type} onClose={handleBalanceClose} onOpen={shopCreditPaymentDialog} editData={selectedData} shopId={shopIdValue ? shopIdValue : ""} onEdit={true} onConfirm={handleConfirm} />}
            {shopPaymentOpen && <PayShopSideBar
                rightSideBarOpen={shopPaymentOpen}
                defaultData={defaultData}
                sideBarTitle={'Shop Payment'}
                handleSubmit={event => { }}
                toggleRightSideBar={handlePayShopClose}
                fromSingleShop={true}
            ><div></div></PayShopSideBar>}
            {transactionDetailsOpen && <TransactionDetailsSideBar
                rightSideBarOpen={transactionDetailsOpen}
                sideBarTitle={'Transaction Details'}
                data={transactionData}
                transData={transactionData}
                payAgain={handlePayAgain}
                cStyle={true}
                onEdit={transactionData && (transactionData.is_broker_enabled || transactionData.tripId || transactionData.vehicleId) ? null : (data) => {
                    handleSingleTransactionEdit(data)
                    setTransactionDetailsOpen(false)
                }}
                onDelete={transactionData && transactionData.is_broker_enabled ? null : (data) => {
                    handleDeleteDialogOpen(data)
                    setTransactionDetailsOpen(false)
                }}
                sideBarSecondaryTitle={"Shop Payment"}
                handleSubmit={event => { }}
                toggleRightSideBar={handleTransactionDetailsClose}
            >
                {transactionData && transactionData.is_broker_enabled ?<>
                    <SingleOnlineTransactionDetailsCard
                        data={transactionData}
                        type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                    />
                    {(transactionData && (transactionData.tripDetails && transactionData.tripDetails.length > 0 || transactionData.tripId)) && <><DottedDivider />
                        <TripListingCard
                            data={transactionData}
                            type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                        /></>}
                </>:<>
                    <PaymentDetailsCard
                        data={transactionData}
                        type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                    />
                    {transactionData && ( transactionData.tripId || transactionData.journeyId || transactionData.vehicleId)  && <DetailsCard
                        data={transactionData}
                        type={transactionData && transactionData.entityType ? transactionData.entityType : null}
                    />}
                </>}  
            </TransactionDetailsSideBar>}
            {successCreation && <SuccessDialog selectedValue={selectedShopData} open={successCreation} title={"Payment Successful"} onClose={handleSuccessClose} />}
            {failureCreation && <FailureDialog selectedValue={selectedShopData} open={failureCreation} title={"Payment Failed"} onClose={handleFailureClose} />}
            {pdfOpen &&
                <ReportsDialog open={pdfOpen} name={"Shop Khata"} fromSingleShopPage={true} shopIdFromSingleShop={shopIdValue ? shopIdValue : ""} onClose={handlePdfClose} />
            }
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchGetSingleShopAndTransaction: (id, data, onSuccess, onFailure) => {
        dispatch(fetchSingleShopAndTransaction(id, data, onSuccess, onFailure));
    },
    dispatchGetTransactionData: (data, onSuccess, onFailure) => {
        dispatch(getShopTransaction(data, onSuccess, onFailure));
    },
    dispatchSettleDriverAmount: (data, onSuccess, onFailure) => {
        dispatch(driverSettleAmount(data, onSuccess, onFailure));
    },
    dispatchFetchSingleDriverTransaction: (id, onSuccess, onFailure) => {
        dispatch(fetchSingleDriverTransaction(id, onSuccess, onFailure))
    },
    dispatchGetDriverDeductionTypes: (onSuccess, onFailure) => {
        dispatch(driverDeductionType(onSuccess, onFailure));
    },
    dispatchGetDriverAdditionTypes: (onSuccess, onFailure) => {
        dispatch(driverAdditionType(onSuccess, onFailure))
    },
    dispatchDeleteSingleTransaction: (id, onSuccess, onFailure) => {
        dispatch(deleteSingleShopTransaction(id, onSuccess, onFailure))
    },
    dispatchGetPaymentStatus: (data, onSuccess, onError) => {
        dispatch(getPaymentStatus(data, onSuccess, onError))
    },
    dispatchGetPaymentDetails: (data, onSuccess, onError) => {
        dispatch(getSinglePayment(data, onSuccess, onError))
    }
})

const ViewShopWithRouter = withRouter(ViewShop);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewShopWithRouter);